import { render } from "./AppTooltip.vue?vue&type=template&id=8c38e47a"
import script from "./AppTooltip.vue?vue&type=script&lang=js"
export * from "./AppTooltip.vue?vue&type=script&lang=js"

import "./AppTooltip.vue?vue&type=style&index=0&id=8c38e47a&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__